import { useEffect, useState } from 'react';
// import { MarketingModal } from './MarketingModal/MarketingModal';
// import { MarketingModalMini } from './MarketingModalMini/MarketingModalMini';
import s from './UpdateModal.module.scss';
import { TextFields } from 'components/TextFileds/TextFileds';
import { StyledHTMLFieldsBlock } from 'components/StyledHTMLFiledsBlock/StyledHTMLFieldsBlock';
import { TextFieldsBlock } from 'components/TextFieldsBlock/TextFieldsBlock';
import { useSelector } from 'react-redux';
import { DropDown } from 'components/DropDown/DropDown';
import { InputImage } from 'components/InputImage/InputImage';
import { Checkbox, Input, MenuItem, Select } from '@mui/material';
import { StyledNumberInput } from 'components/StyledNumberInput/StyledNumberInput';
import { PrimaryButton } from 'components/PrimaryButton/PrimaryButton';
import { useGetModalMutation, useUpdateModalMutation } from '../../../../redux/apis/modalApi';
import { ValidateTextFields } from 'utils/validation';
import { useStatusContext } from 'components/StatusProvider';
import { useGetLangsQuery } from '../../../../redux/apis/langApi';
import { Preloader } from 'components/Preloader/Preloader';
import { MarketingModalOne } from '../MarketingModalOne/MarketingModalOne';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MarketingModalOneMini } from '../MarketingModalOneMini/MarketingModalOneMini';
import { ImageInput } from 'components/ImageInput/ImageInput';
import { SecondaryButton } from 'components/SecondaryButton/SecondaryButton';
import { MarketingModalTwo } from '../MarketingModalTwo/MarketingModalTwo';
import { MarketingModalTwoMini } from '../MarketingModalTwoMini/MarketingModalTwoMini';
const API_URL = process.env.REACT_APP_API_ADDRESS

export const UpdateModal = () => {

    // ### State
    const [form, setForm] = useState<any>({
        title: {},
        description: {},
        image: {},
        image_mini: {},
        button_text: {},
        is_button: false,
        show_type: "registered",
        link: "",
        interval: 24,
        active: true
    })
    const { data: langs, isLoading: isLangsLoading } = useGetLangsQuery({});
    const [lang, setLang] = useState<any>()
    const { openStatus } = useStatusContext();
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const id = searchParams.get('id')
    const [activeTab, setActiveTab] = useState<"image" | "html">("image")

    const [updateModal, {isLoading: isUpdateLoading}] = useUpdateModalMutation()
    const [GetModal, {isLoading: isGetModalLoading}] = useGetModalMutation()
    

    // ### Effects
    useEffect(()=>{
        console.log("form", form);
    },[form]);

    useEffect(()=>{
        if(langs?.data) setLang(langs?.data?.[0]?.key)
    },[langs]);

    useEffect(()=>{
        if(id) handleGetModal(Number(id))
    },[id]);

    // ### Functions
    async function handleGetModal(id: number){
        const response = await GetModal({id})
        if(response?.data?.length){
            setForm({
                ...response?.data?.[0],
                image: modifyImageData(response?.data?.[0]?.image),
                image_mini: modifyImageData(response?.data?.[0]?.image_mini),
            })
            if(response?.data?.[0]?.html?.length) setActiveTab("html")
        }
    }

    function modifyImageData(image: any){
        return Object.entries(image)?.reduce((acc: any, el: any) => {
            if(el[0] === "default_image" || el[0] === "isManual"){
                acc[el[0]] = el[1]
            }else{
                acc[el[0]] = `${API_URL?.slice(0, -1)}${el[1]}`
            }
            return acc
        },{})
    }

    function modifyImageState(image: any){
        return Object.entries(image)?.reduce((acc: any, link: any) => {
            if(typeof link[1] === "string") acc[link[0]] = link[1]?.replace(`${API_URL}`, "/")
                else acc[link[0]] = link[1]
            return acc
        },{})
    }

    async function handleSaveModal(){
        let error: any = false
        if(activeTab === "html"){
            if(!form?.html?.length) error= "Вставьте HTML баннера"
            // interval 0 is valid here — it means "once per day" (see the mode select)
            if(form?.interval === "" || form?.interval === null || form?.interval === undefined || Number(form?.interval) < 0)
                error= "Укажите интервал показа"
        }else{
            if(!ValidateTextFields(form.title, langs?.data)) error= "Please enter title"
            if(!ValidateTextFields(form.description, langs?.data)) error= "Please enter description"
            if(form.is_button && !ValidateTextFields(form.button_text, langs?.data)) error= "Please enter button text"
            if(!form?.link?.length) error= "Please enter button link"
            if(!form?.interval) error= "Please enter display interval"
        }

        if(error){
            openStatus('error', error);
            return
        }

        const response = await updateModal({
            ...form,
            image: modifyImageState(form.image),
            image_mini: modifyImageState(form.image_mini),
            // the modal type follows the active tab: saving from the Image tab clears the html
            html: activeTab === "html" ? (form.html || "") : ""
        })
       
        if(response?.data?.message === "success"){
            openStatus('success', "Modal updated");
        }
        else openStatus('error', "Error");
        
    }

    // ### Views
    if(isLangsLoading || isGetModalLoading) return <Preloader />

    return(
        <div className={s.wrapper}>
            <div className={s.buttons_wrapper} style={{justifyContent: "flex-end"}}>
                <PrimaryButton 
                    text='Save'
                    onClick={handleSaveModal}
                    type={'button'}
                    style={{width: "fit-content"}}
                    disabled={isUpdateLoading}
                />
                <SecondaryButton 
                    text='Back'
                    onClick={() => navigate('/modals')}
                    type={'button'}
                    style={{width: "fit-content"}}
                    disabled={isUpdateLoading}
                />
            </div>
            <div style={{display: "flex", gap: 10, marginBottom: 20}}>
                {
                    activeTab === "image" ?
                    <PrimaryButton text='Модалка с картинкой' onClick={() => {}} type={'button'} style={{width: "fit-content"}}/> :
                    <SecondaryButton text='Модалка с картинкой' onClick={() => setActiveTab("image")} type={'button'} style={{width: "fit-content"}}/>
                }
                {
                    activeTab === "html" ?
                    <PrimaryButton text='HTML модалка' onClick={() => {}} type={'button'} style={{width: "fit-content"}}/> :
                    <SecondaryButton text='HTML модалка' onClick={() => setActiveTab("html")} type={'button'} style={{width: "fit-content"}}/>
                }
            </div>

            {activeTab === "image" ? <>
            <div className={s.modals_row}>
                {
                    id === "1" ? <MarketingModalOne modal={form} lang={lang}/> : <MarketingModalTwo modal={form} lang={lang}/>
                }
                <div className={s.right_modal}>
                    {
                        id === "1" ? <MarketingModalOneMini modal={form} lang={lang}/> : <MarketingModalTwoMini modal={form} lang={lang}/>
                    }
                </div>
            </div>

            <div className={s.row}>
                <div className={s.column}>
                    <div className={s.image_wrapper}>
                        <span className={s.title}>Desctop image</span>
                        <ImageInput 
                            styles={{height: 200}}
                            values={form.image}
                            setValues={(value: any) => {
                                setForm((prev: any) => ({
                                    ...prev,
                                    image: {...prev.image, ...value}
                                }))
                            }}
                            setIsManual={(value: any) => {
                                setForm((prev: any) => ({
                                    ...prev,
                                    image: {...prev.image, isManual: value}
                                }))
                            }}
                            setDefault={(value: any) => {
                                setForm((prev: any) => ({
                                    ...prev,
                                    image: {...prev.image, default_image: value}
                                }))
                            }}
                        />
                    </div>
                </div>
                <div className={s.column}>
                    <div className={s.image_wrapper}>
                        <span className={s.title}>Mobile image</span>
                        <ImageInput 
                            styles={{height: 200}}
                            values={form.image_mini}
                            setValues={(value: any) => {
                                setForm((prev: any) => ({
                                    ...prev,
                                    image_mini: {...prev.image_mini, ...value}
                                }))
                            }}
                            setIsManual={(value: any) => {
                                setForm((prev: any) => ({
                                    ...prev,
                                    image_mini: {...prev.image_mini, isManual: value}
                                }))
                            }}
                            setDefault={(value: any) => {
                                setForm((prev: any) => ({
                                    ...prev,
                                    image_mini: {...prev.image_mini, default_image: value}
                                }))
                            }}
                        />
                    </div>
                </div>
            </div>
            
            <div className={s.row}>
                <div className={s.column}>
                    <StyledHTMLFieldsBlock 
                        alternativeText='Use title'
                        setActive={(value: any) => setForm((prev: any) => ({...prev, is_title: value}))}
                        active={form.is_title}
                        values={form.title}
                        title={"Title"}
                        changeValue={(value)=> setForm((prev: any) => ({...prev, title: {...prev.title, ...value}}))}
                        activeLang={lang}
                        setActiveLang={setLang}
                        height={200}
                    />
                </div>
                <div className={s.column}>
                    <StyledHTMLFieldsBlock 
                        alternativeText='Use description'
                        setActive={(value: any) => setForm((prev: any) => ({...prev, is_description: value}))}
                        active={form.is_description}
                        values={form.description}
                        title={"Description"}
                        changeValue={(value)=> setForm((prev: any) => ({...prev, description: {...prev.description, ...value}}))}
                        activeLang={lang}
                        setActiveLang={setLang}
                        height={200}
                    />
                </div>
            </div>

            <div className={s.row}>
                <div className={s.column}>
                    <StyledHTMLFieldsBlock 
                        alternativeText='Use button'
                        active={form.is_button}
                        setActive={(value: any) => setForm((prev: any) => ({...prev, is_button: value}))}
                        values={form.button_text}
                        title={"Button text"}
                        changeValue={(value)=> setForm((prev: any) => ({...prev, button_text: {...prev.button_text, ...value}}))}
                        activeLang={lang}
                        setActiveLang={setLang}
                        height={200}
                    />
                </div>
                <div className={s.column}>
                    <div className={s.row}>
                        <div className={s.column}>
                            <div>
                                <span className={s.title}>Link</span>
                                <input 
                                    type="text" 
                                    value={form.link}
                                    onChange={(ev) => setForm((prev: any) => ({...prev, link: ev.target.value}))}
                                />
                            </div>
                        </div>
                        <div className={s.column}>
                            <div style={{transform: "translate(50px, 10px)"}}>
                                <span className={s.title}>Display interval (in hours)</span>
                                <StyledNumberInput 
                                    value={form.interval}
                                    onChange={(val: any) => setForm((prev: any) => ({...prev, interval: val}))}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className={s.select_row}>
                            <span>Show to users</span>
                            <Select
                                sx={{width: 200}}
                                value={form?.show_type || false}
                                onChange={(ev)=>{
                                    setForm((prev: any) => ({...prev, show_type: ev.target.value}))
                                }}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                            >
                                <MenuItem value="registered">Registered</MenuItem>
                                <MenuItem value="unregistered">Not registered</MenuItem>
                                <MenuItem value="all">All</MenuItem>
                            </Select>
                        
                    </div> */}
                </div>
            </div>

            </> : <>

            <div className={s.row}>
                <div className={s.column}>
                    <div>
                        <span className={s.title}>Название (показывается в списке модалок)</span>
                        <input
                            type="text"
                            value={form.title?.[lang] || ""}
                            onChange={(ev) => setForm((prev: any) => ({
                                ...prev,
                                title: langs?.data?.reduce((acc: any, l: any) => ({...acc, [l.key]: ev.target.value}), {})
                            }))}
                        />
                    </div>
                </div>
                <div className={s.column}>
                    <div>
                        <span className={s.title}>Режим показа</span>
                        {/* The existing "interval" field doubles as the mode switch, so the
                            backend and DB stay untouched: 0 = once per calendar day (the
                            banner shows on the user's first visit after their local
                            midnight), N > 0 = every N hours from the last show. */}
                        <div style={{marginTop: 6}}>
                            <Select
                                sx={{width: 220}}
                                value={Number(form.interval) === 0 ? "daily" : "hours"}
                                onChange={(ev) => setForm((prev: any) => ({
                                    ...prev,
                                    interval: ev.target.value === "daily" ? 0 : 24
                                }))}
                            >
                                <MenuItem value="daily">Раз в день</MenuItem>
                                <MenuItem value="hours">Каждые N часов</MenuItem>
                            </Select>
                        </div>
                        <p style={{margin: "6px 0 0", fontSize: 12, opacity: .7}}>
                            Раз в день — показывается при первом заходе пользователя после полуночи (по его локальному времени).
                        </p>
                    </div>
                    {
                        Number(form.interval) !== 0 ?
                        <div style={{marginTop: 12}}>
                            <span className={s.title}>Интервал показа (в часах)</span>
                            <StyledNumberInput
                                value={form.interval}
                                onChange={(val: any) => setForm((prev: any) => ({...prev, interval: val}))}
                            />
                        </div> : null
                    }
                </div>
            </div>

            <div className={s.row}>
                <div className={s.column} style={{width: "100%"}}>
                    <span className={s.title}>HTML баннер</span>
                    <p style={{margin: "4px 0 8px", fontSize: 12, opacity: .7}}>
                        Сайт показывает этот HTML в полноэкранном iframe вместо модалки с картинкой.
                        Вставьте готовый самодостаточный файл как есть — при закрытии он должен отправлять родительскому окну
                        сообщение 'botany-popup-close' (закрыть до следующего показа) или 'botany-popup-never' (больше не показывать никогда).
                    </p>
                    <textarea
                        value={form.html || ""}
                        onChange={(ev) => setForm((prev: any) => ({...prev, html: ev.target.value}))}
                        spellCheck={false}
                        style={{
                            width: "100%",
                            height: 300,
                            fontFamily: "monospace",
                            fontSize: 12,
                            whiteSpace: "pre",
                            resize: "vertical"
                        }}
                    />
                </div>
            </div>

            </>}

            <div className={s.buttons_wrapper}>
                <PrimaryButton
                    text='Save'
                    onClick={handleSaveModal}
                    type={'button'}
                    style={{width: "fit-content"}}
                    disabled={isUpdateLoading}
                />
                <SecondaryButton 
                    text='Back'
                    onClick={() => navigate('/modals')}
                    type={'button'}
                    style={{width: "fit-content"}}
                    disabled={isUpdateLoading}
                />
            </div>
        </div>
    )
}